import React from "react";

import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const SessionExpiryModal = ({
  open,
  onLogout,
  onExtend,
  isExtending,
  isLoggingOut,
}) => {
  return (
    <ModalWrapper
      title="Session Expiring Soon"
      show={open}
      maxWidth="xs"
      showCloseIcon={false}
      showTitleDivider={false}
      dialogProps={{ disableEscapeKeyDown: true }}
      actionButtons={[
        {
          label: "Log Out",
          variant: "outlined",
          onClick: onLogout,
          disabled: isExtending,
          isLoading: isLoggingOut,
        },
        {
          label: "Extend Session",
          variant: "contained",
          onClick: onExtend,
          disabled: isLoggingOut,
          isLoading: isExtending,
        },
      ]}
    >
      <p className="mb-3">Your session is about to expire.</p>

      <p>
        Please extend your session to continue working and avoid being
        automatically logged out.
      </p>
    </ModalWrapper>
  );
};

export default SessionExpiryModal;
